import { useState, useEffect } from 'react';
import CustomerLogin from './CustomerLogin';
import CustomerDashboard from './CustomerDashboard';

function CustomerPortal() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    // Check if user is already logged in
    const sessionToken = localStorage.getItem('customer_session');
    if (sessionToken) {
      setIsAuthenticated(true);
    }
  }, []);

  const handleLoginSuccess = () => {
    setIsAuthenticated(true);
  };

  const handleLogout = () => {
    setIsAuthenticated(false);
  };

  if (!isAuthenticated) {
    return <CustomerLogin onLoginSuccess={handleLoginSuccess} />;
  }

  return <CustomerDashboard onLogout={handleLogout} />;
}

export default CustomerPortal;
